import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@els/els-react--button';

function NotAnonShibbolethLogin({ isShibbolethUser, userHasRegistration, onRegisterClick, onSignInClick }) {
  return (
    <>
      {!isShibbolethUser && userHasRegistration && (
        <li className="u-els-padding-left-2x u-els-display-none@tablet">
          <Button id="header-register" className="e2e-header-register" onClick={onRegisterClick}>
            Register
          </Button>
        </li>
      )}
      <li className="u-els-padding-left-1x u-els-display-flex u-els-display-none@tablet">
        <Button
          id="not-anon-shibbo-sign-in"
          className="u-els-color-n8 u-els-font-size-h4 rx-no-wrap"
          data-e2e="not-anon-sign-in"
          type="borderless"
          onClick={onSignInClick}
          href="#"
          aria-label="Sign in">
          Sign in
        </Button>
      </li>
    </>
  );
}

NotAnonShibbolethLogin.propTypes = {
  isShibbolethUser: PropTypes.bool,
  userHasRegistration: PropTypes.bool,
  onRegisterClick: PropTypes.func.isRequired,
  onSignInClick: PropTypes.func.isRequired,
};

export default NotAnonShibbolethLogin;
